/* created by CoolGuy on 2019/1/1 */
import {observable,action} from 'mobx';
const galleryApi = require('../actions/gallery');
// 这个class的出现时间很晚，所以很多和gallery相关的功能是直接调用的action里边的gallery
export default class GalleryStore {
    constructor(rootStore){
        this.rootStore = rootStore;
    }
    one = (id)=>{
        return galleryApi.one(id).then(jsonData=>{
            this.setOneGallery(jsonData);
            // 一个基础方法里想要使用相册配置，这个有点难搞，先临时这个处理一下吧
            window.__current_gallery__ = jsonData || {};
            return jsonData;
        })
    }
    @observable currentGallery={};
    @action setOneGallery = (obj)=>{
        this.currentGallery = obj || {};
    }
}



// WEBPACK FOOTER //
// ./src/store/GalleryStore.js